<template>
  <v-app>
    <v-toolbar fixed app color="secondary lighten-1" class="elevation-0" :dense="$vuetify.breakpoint.smAndDown" dark>
      <v-toolbar-side-icon @click.stop="drawer = !drawer" v-if="IS_SIGNED_INTO_CABLE || IS_SIGNED_INTO_MPX">
      </v-toolbar-side-icon>
      <router-link :to="{ name: 'Home' }">
        <img src="./assets/cts-logo.png" class="cts-logo" :class="{ 'dense': $vuetify.breakpoint.smAndDown }" alt="">
      </router-link>
      <v-toolbar-title v-text="title" class="pl-1">
      </v-toolbar-title>
      <label class="caption ml-2 mt-1" v-if="envName !== ''">({{ envName }} - {{ appVersion }})</label>
      <label class="caption ml-2 mt-1" v-else>(Version - {{ appVersion }})</label>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <!-- <v-btn flat
               @click="navigateToHelp">
          <v-icon left
                  dark>help_outline</v-icon>
          Help
        </v-btn> -->
      </v-toolbar-items>
      <UserFlyout></UserFlyout>
    </v-toolbar>
    <v-navigation-drawer fixed v-model="drawer" width="250" temporary clipped app class="vop-nav-background">
      <v-list subheader class="ttu vop-nav-list">
        <v-list-tile class="my-3" @click.stop="drawer = !drawer">
          <v-list-tile-content>
            <img src="./assets/cts-logo.png" class="cts-logo" :class="{ 'dense': $vuetify.breakpoint.smAndDown }"
              alt="">
          </v-list-tile-content>
        </v-list-tile>
        <!-- Home -->
        <v-list-tile v-for="item in homeItems" :key="item.pathName" :to="{ 'name': item.pathName }"
          class="indigo--text text--lighten-5" active-class="white--text">
          <v-list-tile-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <!-- Query -->
        <v-subheader class="light-blue--text text--lighten-5" v-if="queryItemsList.length > 0">QUERY</v-subheader>
        <v-list-tile v-for="item in queryItemsList" :key="item.pathName" :to="{ 'name': item.pathName }"
          class="indigo--text text--lighten-5" active-class="white--text">
          <v-list-tile-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-subheader class="light-blue--text text--lighten-5" v-if="configurationItemsList.length > 0">CONFIGURATION
        </v-subheader>
        <v-list-tile v-for="item in configurationItemsList" :key="item.pathName" :to="{ 'name': item.pathName }"
          class="indigo--text text--lighten-5" active-class="accent--text">
          <v-list-tile-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-menu open-on-hover right offset-x v-if="item.children">
              <template v-slot:activator="{ on }">
                <v-list-tile-title v-on="on">{{ item.title }}</v-list-tile-title>
              </template>
              <v-list class="vop-child-menu">
                <v-list-tile v-for="item in item.children" :key="item.pathName" :to="{ 'name': item.pathName }"
                  class="indigo--text text--lighten-5" active-class="accent--text">
                  <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
            <v-list-tile-title v-else>{{ item.title }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
    <v-content>
      <v-container fluid class="pa-0" fill-height align-start align-content-start grid-list-md>
        <keep-alive>
          <router-view />
        </keep-alive>
      </v-container>
    </v-content>
    <v-footer app dark height="auto" class="px-2">
      <span>&copy; Comcast Technology Solutions</span>
    </v-footer>
  </v-app>
</template>

<script>
import { mapState, mapGetters } from "vuex"
import UserFlyout from "@/Auth/UserFlyout.vue"
import AppService from "@/AppService"
import * as appDataService from "@/AppDataService"
import * as authDataService from "@/Auth/AuthDataService"
import packageJSON from "../package.json"
import { IS_SIGNED_INTO_CABLE, IS_SIGNED_INTO_MPX } from "@/store/constants/getter-types"

export default {
  components: {
    UserFlyout
  },
  data() {
    return {
      drawer: false,
      homeItems: [
        {
          icon: "home",
          title: "Home",
          pathName: "Home"
        }
      ],
      queryItems: AppService.getQueryItems(),
      configurationItems: AppService.getConfigurationItems(),
      title: "VOD Operations Platform",
    }
  },
  computed: {
    ...mapGetters([
      IS_SIGNED_INTO_CABLE,
      IS_SIGNED_INTO_MPX
    ]),
    ...mapState([
      "mpxParentAccount"
    ]),
    queryItemsList() {
      return this.filterVisibileFeaturesList(this.queryItems)
    },
    configurationItemsList() {
      return this.filterVisibileFeaturesList(this.configurationItems)
    },
    envName() {
      return AppService.getEnvName()
    },
    appVersion() {
      return packageJSON.version
    }
  },
  methods: {

    /**
     * filterVisibileFeaturesList
     * @param {array} featureItems
     * @returns {array}
     */
    filterVisibileFeaturesList(featureItems) {
      return this.$lodash.filter(featureItems, (item) => {
        let isAuthenticated = (item.auth === "MPX" && this.IS_SIGNED_INTO_MPX) ||
          (item.auth === "CABLE" && this.IS_SIGNED_INTO_CABLE)
        let isVisible = AppService.isFeatureVisible(item.featureName)
        let hasAccess = this.hasAccessToFeature(item)
        return isAuthenticated && isVisible && hasAccess
      })
    },

    /**
     * hasAccessToFeature
     * @param {objct} item
     * @returns {boolean}
     */
    hasAccessToFeature(item) {
      if (item.auth === "MPX") {
        if (this.$lodash.isEmpty(this.mpxParentAccount) ||
          this.$lodash.isUndefined(this.mpxParentAccount)) {
          return false
        }
        let services = this.mpxParentAccount._service
        let mvatsFeatures = ["metadataRules"]
        let opsUIFeatures = ["preIngest", "providerGroups", "providerList"]
        if (this.$lodash.indexOf(mvatsFeatures, item.featureName) > -1 &&
          this.$lodash.indexOf(services, AppService.getMvatsServiceString()) > -1) {
          return true
        }
        if (this.$lodash.indexOf(opsUIFeatures, item.featureName) > -1 &&
          this.$lodash.indexOf(services, AppService.getOpsUIServiceString()) > -1) {
          return true
        }
      } else if (item.auth === "CABLE") {
        return true
      }
    },

    /**
     * Navigate to help page
     */
    navigateToHelp() {
      let helpURL = "https://docs.theplatform.com/help/vod-operations-platform"
      window.open(helpURL, "_blank")
    }
  },
  created() {
    // Setup interceptors
    AppService.setUpInterceptors()

    /**
     * Global Events
     * */

    AppService.$on("event:mpxInvalidToken", () => {
      //  Clear user data
      appDataService.setMPXUserInfo({})
      // reload the view
      window.location.href = "/#/mpx-login?token=false"
    })

    AppService.$on("event:cableInvalidToken", () => {
      if (this.$router.currentRoute) {
        appDataService.setRedirectPath(this.$router.currentRoute.name)
      }
      appDataService.setCableUserInfo({})
        .then(() => {
          //  Clear out user data
          AppService.$emit("event:cableSignOutSuccess")
          //  Redirect the user to SSO login
          authDataService
            .getWebSecUrl()
            .then((authorizationUrl) => {
              window.location.href = authorizationUrl
            })
        })
    })
  }
}
</script>
<style>
.cts-logo {
  width: 180px;
  height: auto;
  cursor: pointer;
}

.cts-logo.dense {
  width: 140px;
  height: auto;
  cursor: pointer;
}

.vop-nav-background {
  background: linear-gradient(rgb(82, 106, 243), rgb(75, 94, 205));
}

.vop-nav-list {
  background: none !important;
}

.vop-nav-list .v-icon {
  color: inherit !important;
}

.vop-child-menu {
  background: rgb(82, 106, 243) !important;
}

.vop-bg-whisper {
  background-color: #fbfbfd !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue